document.addEventListener('DOMContentLoaded',()=>{
  document.querySelectorAll('[data-add-to-cart]').forEach(form=>{
    form.addEventListener('submit',async e=>{
      e.preventDefault();
      const btn=form.querySelector('button');
      if(!btn) return;
      const old=btn.textContent; btn.textContent='Adding…'; btn.disabled=true;
      try{
        const res=await fetch('/cart/add.js',{method:'POST',headers:{'Accept':'application/json'},body:new FormData(form)});
        if(!res.ok) throw new Error();
        btn.textContent='Added ✓';
        setTimeout(()=>{btn.textContent=old;btn.disabled=false},1200);
        const count=await fetch('/cart.js').then(r=>r.json());
        document.querySelectorAll('.cartCount').forEach(x=>x.textContent=count.item_count);
      }catch(err){btn.textContent='Try again';setTimeout(()=>{btn.textContent=old;btn.disabled=false},1500)}
    });
  });

  // Flipkart-style inline search: opens on the same page and shows live product suggestions.
  const toggle=document.querySelector('.searchToggle');
  const overlay=document.getElementById('VintagelySearch');
  const input=document.getElementById('QuickSearchInput');
  const results=document.getElementById('QuickSearchResults');
  const closeBtn=document.querySelector('.quickSearchClose');
  if(toggle && overlay && input && results){
    let timer;
    const closeSearch=()=>{
      overlay.hidden=true;
      toggle.setAttribute('aria-expanded','false');
      document.body.classList.remove('searchOpen');
      results.innerHTML='';
    };
    const openSearch=()=>{
      overlay.hidden=false;
      toggle.setAttribute('aria-expanded','true');
      document.body.classList.add('searchOpen');
      setTimeout(()=>input.focus(),40);
    };
    toggle.addEventListener('click',()=>overlay.hidden?openSearch():closeSearch());
    if(closeBtn) closeBtn.addEventListener('click',closeSearch);
    document.addEventListener('keydown',e=>{
      if(e.key==='Escape' && !overlay.hidden) closeSearch();
    });

    input.addEventListener('input',()=>{
      clearTimeout(timer);
      const q=input.value.trim();
      if(!q){results.innerHTML='<div class="searchHint">Search by sneaker name or brand.</div>';return;}
      timer=setTimeout(async()=>{
        results.innerHTML='<div class="searchHint">Searching…</div>';
        try{
          const url='/search/suggest.json?q='+encodeURIComponent(q)+'&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=hide';
          const res=await fetch(url,{headers:{'Accept':'application/json'}});
          if(!res.ok) throw new Error();
          const data=await res.json();
          const products=(data.resources && data.resources.results && data.resources.results.products)||[];
          if(!products.length){
            results.innerHTML='<div class="searchHint">No sneakers found for “'+escapeHtml(q)+'”.</div>';
            return;
          }
          results.innerHTML=products.map(p=>{
            const img=p.featured_image && (p.featured_image.url || p.featured_image);
            const price=p.price || '';
            return '<a class="quickSearchProduct" href="'+escapeAttr(p.url)+'">'+
              (img?'<img src="'+escapeAttr(img)+'" alt="" loading="lazy">':'<span class="quickSearchProductImage">VG</span>')+
              '<span><strong>'+escapeHtml(p.title)+'</strong><small>'+escapeHtml(price)+'</small></span></a>';
          }).join('')+
          '<a class="quickSearchAll" href="/search?q='+encodeURIComponent(q)+'&type=product">View all results for “'+escapeHtml(q)+'” ↗</a>';
        }catch(err){
          results.innerHTML='<div class="searchHint">Search is temporarily unavailable. Try again.</div>';
        }
      },220);
    });

    function escapeHtml(value){
      return String(value).replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
    }
    function escapeAttr(value){return escapeHtml(value);}
  }
});

// Cart quantity + / - controls
document.addEventListener('click',(e)=>{
  const btn=e.target.closest('[data-qty-minus],[data-qty-plus]');
  if(!btn) return;
  const wrap=btn.closest('[data-qty-control]');
  const input=wrap && wrap.querySelector('.qtyInput');
  if(!input) return;
  let value=parseInt(input.value,10) || 0;
  if(btn.hasAttribute('data-qty-plus')) value += 1;
  else value = Math.max(0, value - 1);
  input.value=value;
});
